// extracted by mini-css-extract-plugin
module.exports =  {"block":"block--ZE4Uw","block_selected":"block_selected--cGXyx","name":"name--wFmhF","tag":"tag--ICDMe","date":"date--XDGBD"};